import {
  createRequestContract,
  createResponseContract,
  createSpec,

  requestVerbs,
  responseTypes,
  specTypes,
} from '@bingads-webui-react/overreact';

import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../../env/edm';
import { environmentLookupFn } from '../../../../../../env/env-instance';
import { schema } from '../../../../../../env/schema';

import {
  headerDecorator,
  sideEffects,

  networkPolicy,
} from './fetch-decorators';

function odataUrlFactory(params) {
  const { variables } = params;
  const { locator: { descriptor } } = variables;
  const {
    customer_id: CustomerId,
    account_id: AccountId,
  } = descriptor;

  const edmEntity = edm
    .Customers.$withKey(CustomerId)
    .Accounts.$withKey(AccountId)
    .Tags;

  const searchString = composeSearchString(variables, edmEntity);
  return `${edmEntity.path}${searchString}`;
}

function odataHeaderFactory(params) {
  const { headers } = params;
  return headers;
}

const requestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:tag',
  verb: requestVerbs.GET,
  fetchPolicy: networkPolicy,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: headerDecorator(odataHeaderFactory),
  keySelector: variables => variables.locator.descriptor.tag_id,
  parentKeySelector: variables => variables.locator.descriptor.account_id,
});

const responseContract = createResponseContract({
  requestContract,
  responseType: responseTypes.COLL,
  keySelector: r => r.Id,
  processorFn: r => r.value,
});

export const fetchSpec = createSpec(
  requestContract,
  responseContract,
  specTypes.PAGINATION,
  sideEffects.pagination,
  environmentLookupFn
);

export const refetchSpec = createSpec(
  requestContract,
  responseContract,
  specTypes.REFETCH,
  sideEffects.refetch,
  environmentLookupFn
);
